<template>
    <div>
        <FormulateInput
        v-if="personalizedType !== 'clipartCategory'"
        :name="layer.id"
        :label="label"
        :shapes="layer.shapes[0]['file']['key']"
        type="imageshape"
        :aspectRatio="aspectRatio"
        />
    </div>
   
</template>

<script>
import { get } from 'lodash'
export default {
  name: 'image-shape-fiels',
  components: {},
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    personalizedType() {
      return this.layer.personalized.type
    },
    required() {
      return get(this.layer, 'personalized.required', false)
    },
    initialValue() {
      const { personalized, layer } = this
      return get(personalized, layer.id)
    },
    label() {
      return get(this.layer, 'personalized.label', this.layer.title)
    },
    aspectRatio() {
      const { layer } = this
      return layer.width / layer.height
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Form/ImageShapeField.vue